export default {
  SET_TOKEN (state, token) {
    state.token = token
  },
  SET_USER (state, user) {
    state.principal = user
  },
  RESET_USER (state, user) {
    state.principal = state.defaultPrincipal
  },
  UPDATE_TIMINGS (state) {
    state.expiresFrom = new Date().getTime()
  },
  UPDATE_ACTIVE_REQUEST_TOGGLE (state, bool) {
    state.hasCurrentActiveRequest = bool
  }
}



// WEBPACK FOOTER //
// ./src/modules/authentication/store/mutations.js